export default class Events {

	static init() {
		return new Events();
	}

	constructor() {
		const container = document.querySelector('.events-calendar-container');
		if (!container)
			return;
			
		const loadMoreProgress = container.querySelector('.load-more-progress');
		let loadMoreEnabled = true;

		window.addEventListener('scroll', () => {
			if (loadMoreEnabled && container && container.getBoundingClientRect().bottom < window.innerHeight - 50) {
				window.Livewire.dispatch('load-more');
				loadMoreProgress.classList.add('loading');
				loadMoreEnabled = false;
			}
		});

		window.Livewire.hook('element.updated', (el, component) => {
			loadMoreEnabled = true;
			loadMoreProgress.classList.remove('loading');
		});
	}
}
